export default __webpack_public_path__ + "static/media/donwload_file_icon.63087a36.svg";